"use client";

import { lazyComponent } from "@/components/ui/lazy-component";
import { LoadFailureNotice } from "@/components/ui/load-failure-notice";

export const PopoverCalendar = lazyComponent(
  () => import("./calendar").then((mod) => mod.Calendar),
  {
    ssr: false,
    loading: <div aria-busy="true" className="h-[18.5rem] w-[15.5rem]" />,
    failure: {
      label: "popover-calendar",
      fallback: (
        <LoadFailureNotice
          title="The calendar could not load."
          className="h-[18.5rem] w-[15.5rem]"
        />
      ),
    },
  },
);
